import React from 'react';

import { StepButton, StepLabel, Typography } from '@mui/material';
import { StepperState } from '../hooks/useStepperState';
import { StepProps } from '../WizardStepper';
import { translate } from 'react-jhipster';

export function buildLabelComponent(
  step: any,
  index: number,
  nonLinear: boolean,
  handleStep: (index: number) => any,
): React.ReactNode {
  const optional =
    step.optional === true ? (
      <Typography variant="caption">{translate('stepper.optional', null, 'Optional')}</Typography>
    ) : React.isValidElement(step.optional) ? (
      step.optional
    ) : null;
  return nonLinear ? (
    <StepButton color="inherit" onClick={handleStep(index)} optional={optional}>
      {step.label}
    </StepButton>
  ) : (
    <StepLabel optional={optional}>{step.label}</StepLabel>
  );
}

export function buildContentComponent(step: StepProps, stepperState: StepperState): React.ReactNode {
  const Wrapper = buildWrapperComponent(step, stepperState);

  if (typeof step.children === 'function') {
    const Content = step.children;

    return (
      <Wrapper>
        <Content stepperState={stepperState} />
      </Wrapper>
    );
  } else if (typeof step.children === 'string') {
    return <Wrapper>{step.children}</Wrapper>;
  }
}

function buildWrapperComponent(step: StepProps, stepperState: StepperState): (children) => React.ReactNode {
  if (step.wrapper && step.wrapper.component) {
    const CustomComponent = step.wrapper.component;
    return ({ children }) => (
      <CustomComponent {...step.wrapper.props} stepperState={stepperState}>
        {children}
      </CustomComponent>
    );
  } else {
    return ({ children }) => children;
  }
}
